<template>
  <div class="scroll_wrap" :style="{width:wid+'px'}">
    <!-- // 外框，固定宽度 -->
    <div id="box">
      <!-- // 内部滚动框 -->
      <div id="marquee" ref="marquee">{{info}}</div>
      <!-- //展示的文字 -->
      <div id="copy"></div>
      <!-- // 文字副本，为了实现无缝滚动 -->
    </div>
    <!-- <div id="node">{{info}}</div> -->
    <!-- //为了获取info实际宽度 -->
  </div>
</template>
<script>
export default {
  name: 'Marquee',
  props: {
    wid: {
      type: String,
      default: '150' //宽度
    },
    info: {
      type: String,
      default: '' //宽度
    }
  },
  // props: ['wid','info'], // 父组件传入数据， 数组形式 [ "连雨不知春去"，"一晴方觉夏深"]
  data () {
    return {
      // info: '父组件传入数据， 数组形式 ' // 数组文字转化后的字符串
    }
  },
  methods: {
    move () {
      // 获取文字info 的计算后宽度  （由于overflow的存在，直接获取不到，需要独立的node计算）
      let width = document.getElementById('marquee').getBoundingClientRect().width
      let box = document.getElementById('box')
      let copy = document.getElementById('copy')
      copy.innerinfo = this.info // 文字副本填充
      let distance = 0 // 位移距离
      //设置位移
      setInterval(function () {
        distance = distance - 1
        // 如果位移超过文字宽度，则回到起点
        if (-distance >= width) {
          distance = 16
        }
        box.style.transform = 'translateX(' + distance + 'px)'
      }, 20)
    }
  },
// 把父组件传入的arr转化成字符串
  mounted () {
    setTimeout(()=>{
      let width = document.getElementById('marquee').getBoundingClientRect().width
      if (width>this.wid) {
        this.move()
      }
    },1000)
  }
}
</script>
<style scoped>
/* // 限制外框宽度，隐藏多余的部分 */
.scroll_wrap {
  overflow: hidden;
  width: 250px;
}
/* // 移动框宽度设置 */
#box {
  width: 80000%;
}
/* // 文字一行显示 */
#box div {
  float: left;
}
/* // 设置前后间隔 */
#marquee {
   margin: 0 16px 0 0;
}
/* // 获取宽度的节点，隐藏掉 */
#node {
  position: absolute;
  z-index: -999;
  top: -999999px;
}
</style>